
export const BASEURL = 'https://evangelismback.thmdatagh.com/v1/';
